import htmlBadge from './assets/badges/html-css.png';
import javascriptBadge from './assets/badges/javascript.png';
import reactBadge from './assets/badges/react-redux.png';
import rubyBadge from './assets/badges/ruby-databases.png';
import railsBadge from './assets/badges/ror.png';
import completionBadge from './assets/badges/completion.png';

const certificates = [
  {
    name: 'Microverse HTML/CSS module',
    description: 'Earn this credential after demonstrating industry standard HTML and CSS skills.',
    img: htmlBadge,
    link: 'https://www.credential.net/78fd494d-211d-4487-ac17-0e8313083c3f#gs.bfj3ql',
  },
  {
    name: 'Microverse JavaScript Module',
    description: 'Earn this credential after demonstrating understanding and mastery of JavaScript.',
    img: javascriptBadge,
    link: 'https://www.credential.net/e2ae8d10-e791-48a3-a44e-3b8b2904495c#gs.bfj34v',
  },
  {
    name: 'Microverse React & Redux Module',
    description: 'Earn this credential after demonstrating thorough understanding and mastery of React and Redux.',
    img: reactBadge,
    link: 'https://www.credential.net/4761faa6-2bf2-4d17-a87c-e66698d45779#gs.bfj148',
  },
  {
    name: 'Microverse Ruby/Databases Module',
    description: 'Earn this credential after demonstrating thorough and complete understanding of Ruby and databases.',
    img: rubyBadge,
    link: 'https://www.credential.net/eebdc1ed-fcb3-4824-9439-9b9ebd1bb98c',
  },
  {
    name: 'Microverse Ruby on Rails Module',
    description: 'Earn this credential upon demonstrating mastery of Ruby on Rails.',
    img: railsBadge,
    link: 'https://www.credential.net/173170ce-2484-4029-913f-0f0aed364d17#gs.bfg3je',
  },
  {
    name: 'Microverse Software Development Program',
    description: 'Earn this credential after working through 1500+ hours of remote pair programming, learning to code with teams from around the world.',
    img: completionBadge,
    link: 'https://www.credential.net/3339769a-9703-4b50-8a04-28c16dec9c49#gs.bfexap',
  },
];

export default certificates;
